import axios from "axios";

axios.defaults.headers.common['Content-Security-Policy'] = 'your-csp-value';
axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
axios.defaults.headers.common['X-Frame-Options'] = 'deny';
axios.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains';
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Pragma'] = 'no-cache';

export async function getApi(url: string) {
    return axios.get(url)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function postApi(url: string, data: any) {
    const request = getHeaders();
    const json = JSON.stringify(data);
    return axios.post(url, json, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function putApi(url: string, data: any) {
    const request = getHeaders();
    const json = JSON.stringify(data);
    return axios.put(url, json, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

export async function deleteApi(url: string) {
    const request = getHeaders();
    return axios.delete(url, request)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            console.log(
                "error api get...................................................",
                error
            );
            return { statusCode: 401 };
        });
}

function getHeaders() {
    return {
        headers: { "Content-Type": "application/json" }
    };
}